import { ref } from 'vue';
import { defineStore } from 'pinia';
import { applyPatch } from 'fast-json-patch';

export const useItemBiddingStore = defineStore('itemBiddingStore', () => {
    const items = ref({});

    function addItemBidding(itemBiddingModel) {
        this.items[itemBiddingModel.id] = itemBiddingModel;
    }

    function updateItemBidding(id, itemBiddingModel) {
        this.items[id] = itemBiddingModel;
    }

    function removeItemBidding(id) {
        delete this.items[id];
    }

    function applyJsonPatch(id, jsonPatch) {
        applyPatch(this.items[id], jsonPatch, false, true);
    }

    return {
        items,
        addItemBidding,
        updateItemBidding,
        removeItemBidding,
        applyJsonPatch
    }
})